import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import * as React from 'react';
import { api } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import { EDeviceType } from '../../header/legacy-header/types.js';
import { useDeviceType } from '../../utils/hooks.js';
import { prependPrefix } from '../../utils/style.js';
import { LegacyDesktopSearchBox } from './legacy-desktop-search-box.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var MobileSearchBox = function MobileSearchBox(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("a", {
    href: "".concat(api.MISSEVAN_MOBILE_API_PREFIX_URL, "/search"),
    className: classNames(prependPrefix('legacy-search'), className)
  });
};

var SearchBox = function SearchBox(props) {
  var deviceType = useDeviceType();
  return deviceType === EDeviceType.Mobile ? /*#__PURE__*/React.createElement(MobileSearchBox, {
    className: props.className
  }) : /*#__PURE__*/React.createElement(LegacyDesktopSearchBox, _objectSpread({}, props));
};

var LegacySearchBox = function LegacySearchBox(props) {
  if (typeof props.isMobile === 'boolean') {
    return props.isMobile ? /*#__PURE__*/React.createElement(MobileSearchBox, {
      className: props.className
    }) : /*#__PURE__*/React.createElement(LegacyDesktopSearchBox, _objectSpread({}, props));
  }

  return /*#__PURE__*/React.createElement(SearchBox, _objectSpread({}, props));
};

export { LegacySearchBox };
